export default "__VITE_ASSET__Cf5YodQm__"